import { Link } from "react-router-dom";
import { Heart, X, ShoppingBag } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";

export default function Wishlist() {
  const { items, remove } = useWishlist();

  return (
    <div className="container-lira py-14 md:py-20 min-h-[60vh]" data-testid="wishlist-page">
      <div className="text-center mb-14">
        <p className="eyebrow mb-3">{items.length} saved</p>
        <h1 className="font-serif text-4xl md:text-6xl font-light tracking-tight">Your Wishlist</h1>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-16">
          <Heart strokeWidth={1} className="h-10 w-10 mx-auto text-[#d8d1c4]" />
          <p className="mt-6 text-[#737373]">You haven't saved anything yet.</p>
          <Link to="/collection/all" className="btn-primary mt-8 inline-flex">Explore the Collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {items.map((p) => (
            <div key={p.slug} className="group flex flex-col gap-4" data-testid={`wishlist-item-${p.slug}`}>
              <div className="relative overflow-hidden aspect-[3/4] bg-beige rounded-sm">
                <Link to={`/product/${p.slug}`}>
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </Link>
                <button onClick={() => remove(p.slug)} aria-label="Remove" className="absolute top-3 right-3 h-9 w-9 grid place-items-center rounded-full bg-white/85 backdrop-blur hover:scale-110 transition-transform" data-testid={`wishlist-remove-${p.slug}`}>
                  <X strokeWidth={1} className="h-4 w-4" />
                </button>
              </div>
              <div>
                <span className="eyebrow">{p.category_label}</span>
                <Link to={`/product/${p.slug}`} className="block font-serif text-xl mt-1">{p.name}</Link>
                <span className="text-sm">${p.price.toFixed(2)}</span>
              </div>
              <Link to={`/product/${p.slug}`} className="btn-secondary text-center"><ShoppingBag strokeWidth={1} className="h-4 w-4 mr-2" /> View</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
